import { FC } from "react";
import { useIntl } from "react-intl";

export const FaqItem: FC<{ index: number }> = ({ index }) => {
  const intl = useIntl();

  return (
    <div>
      <div className="flex items-center">
        <div className="font-bold border-r-4 border-[#6e5f49] py-4 min-w-14 me-4 text-xl self-stretch">
          Q{index}
        </div>
        <div className="flex-grow">
          {intl.formatMessage({ id: `faq.ques${index}` })}
        </div>
      </div>
      <div className="flex items-center">
        <div className="font-bold border-r-4 border-[#6e5f49] py-4 min-w-14 me-4 text-xl self-stretch">
          A{index}
        </div>
        {index === 8 ? (
          <div className="flex-grow">
            {intl.formatMessage({ id: `faq.ans${index}_1` })}
            <table>
              <tbody>
                <tr>
                  <td className="px-2">•</td>
                  <td>{intl.formatMessage({ id: `faq.ans${index}_2` })}</td>
                  <td> : {intl.formatMessage({ id: `faq.ans${index}_3` })}</td>
                </tr>
                <tr>
                  <td className="px-2">•</td>
                  <td>{intl.formatMessage({ id: `faq.ans${index}_4` })}</td>
                  <td> : {intl.formatMessage({ id: `faq.ans${index}_5` })}</td>
                </tr>
                <tr>
                  <td className="px-2">•</td>
                  <td>{intl.formatMessage({ id: `faq.ans${index}_6` })}</td>
                  <td> : {intl.formatMessage({ id: `faq.ans${index}_7` })}</td>
                </tr>
              </tbody>
            </table>
            {intl.formatMessage({ id: `faq.ans${index}_8` })}
          </div>
        ) : (
          <div
            className="flex-grow"
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({ id: `faq.ans${index}` }),
            }}
          />
        )}
      </div>
    </div>
  );
};
